export default __webpack_public_path__ + "2024 Coherent anharmonicity transfer from matter to light in the THz regime.pdf";